export const PaymentRoute = {
  Payment: (): string => '/payment/pay',
};
